import clsx from 'clsx';
import React from 'react';
import EditIcon from '../../assets/icons/edit-icon.svg?react';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import Input from '../Input';
import { DepartmentWithCount } from '@EHSNavigator/backend';

interface EditDepartmentDetailsModalProps {
  otherClasses?: string;
  handleClose: () => void;
  formHandler: any;
  currentDepartment: DepartmentWithCount;
}

const EditDepartmentDetailsModal: React.FC<EditDepartmentDetailsModalProps> = ({
  otherClasses,
  currentDepartment,
  handleClose,
  formHandler,
}) => {
  const editDepartmentDetailsModalClasses = clsx(otherClasses);

  return (
    <div
      className={editDepartmentDetailsModalClasses}
      data-testid="edit-department-details-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <EditIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-byzantine">Edit Department Details</h4>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <div className="mt-2.5 grid grid-cols-1">
          <Input
            onBlur={formHandler?.handleBlur}
            label="Department Name"
            errorMessage={
              formHandler?.touched.name && formHandler?.errors.name
                ? formHandler?.errors.name
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.name}
            type="text"
            placeholder="Department name here..."
            onChange={formHandler?.handleChange}
            name="name"
            otherClasses={{ container: 'w-full' }}
          />
        </div>

        <div className="mt-12 grid grid-cols-1">
          <Input
            onBlur={formHandler?.handleBlur}
            label="Department Prefix"
            errorMessage={
              formHandler?.touched.prefix && formHandler?.errors.prefix
                ? formHandler?.errors.prefix
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.prefix}
            type="text"
            placeholder="Department prefix here..."
            onChange={formHandler?.handleChange}
            name="prefix"
            otherClasses={{ container: 'w-full' }}
          />
        </div>

        <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={useButtonSizeSmall()}
            onClick={() => handleClose()}
            otherClasses="text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
          >
            Discard Changes
          </Button>
          <Button
            loading={formHandler?.isSubmitting}
            disable={
              (formHandler?.values.name === currentDepartment?.name &&
                formHandler?.values.prefix === currentDepartment?.prefix) ||
              formHandler?.isSubmitting
            }
            type="submit"
            size={useButtonSizeSmall()}
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditDepartmentDetailsModal;
